import {
  Component,
  Input,
  Directive, ContentChildren, QueryList, OnInit, ContentChild, Output, EventEmitter
} from '@angular/core';
import { NgbModal } from '../../modal/modal.module';


@Directive({ selector: 'clo-profile-menu-item' })
export class CloProfileMenuItem {

  /**
   *  The time from the notification being created to now as a string (ex: '2 minutes ago')
   */
  @Input() label: string;
  @Input() labelFont: any;
}
@Directive({ selector: 'clo-profile-user' })
export class CloProfileUser {

  /**
   *  The url for the user's avatar/profile image
   */
  @Input() avatarSrc: string;

  /**
   *  The name of the company
   */
  @Input() companyName: string;

  /**
   *  The user's title
   */
  @Input() title: string;

  /**
   *  The username
   */
  @Input() username: string;
}


@Component({
  selector: 'clo-profile-menu',
  templateUrl: './profile-menu.html',
  styleUrls: ['./profile-menu.css']
})
export class CloProfileMenu implements OnInit {
  @ContentChildren(CloProfileMenuItem) items: QueryList<CloProfileMenuItem>;
  @ContentChild(CloProfileUser, { static: false }) user !: CloProfileUser;
  @Output() profileItemClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalService: NgbModal) { }

  open(content) {
    this.modalService.open(content, { windowClass: 'hamburgerModal headerModal' });
  }

  profileMenuItemsClick(item) {
     this.profileItemClicked.emit(item);
  }

  ngOnInit() {
    // this.unread = (this.items.find(i => i.read === true)) ? true : false;
  }


}
